// lib/supabaseClient.ts - 單例化 Supabase client
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

const SUPABASE_URL = "https://dsihxrgqlyrarqqgryin.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzaWh4cmdxbHlyYXJxcWdyeWluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk1MzkzMDgsImV4cCI6MjA2NTExNTMwOH0.AEhgH6A_54zjzg8RZgeNaii6VJ4eONVhfoAWzquWDXI";

// 只在模組頂層建一次；各頁 import 同一個實例
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,     // 將 session 保存在 localStorage
    autoRefreshToken: true,   // 自動刷新 token
    detectSessionInUrl: true  // 檢測 URL 中的 session 信息
  }
});
